module.exports = __webpack_public_path__ + "media/images/bg-leaderboard-24f7ea707111dbc84315907aa6bf84d4.svg";